<template lang="pug">
  .swatch-selector.xs-f-small.max-at-tweak
    .mobile-wrap(v-if="breakpoint == 'mobile' || breakpoint == 'tablet' || breakpoint == 'desktop-md'")
      .mobile-swatches
        horizontal-selector(:selected-index="currentSlide" :show-arrows="showArrows" @swipe-left="swipeLeft" @swipe-right="swipeRight")
          .swatch-outer-wrap(v-for="(swatch, index) in swatches" :class="{'best-match': swatch.bestMatch || swatch.subscribed, 'selected' : swatch.selected}" :key="index")
            span.best-match-text.color-white.xs-f-xxsmall.max-at-tweak(v-if="swatch.bestMatch || swatch.subscribed") {{swatch.subscribed ? 'Subscribed' : 'Best Match'}}
            PdpSwatchButton.swatch-wrap(:disabled="swatch.disabled" :selected="swatch.selected" :label="swatch.title" :img-url="swatch.imageUrl" :img-alt-text="swatch.imageAltText" @click="selectSwatch(swatch, index)")

      button.left-arrow.btn-reset.xs-f-small.max-at-tweak(v-if="showArrows && currentSlide > 0 && swatches.length > 3" @click="clickLeft")
        span.ada-tooltip left
        span.icon-caret-left
      button.right-arrow.btn-reset.xs-f-small.max-at-tweak(v-if="showArrows && currentSlide < swatches.length - 1 && swatches.length > 3" @click="clickRight")
        span.ada-tooltip right
        span.icon-caret-right

    template(v-else)
      .desktop-wrap(:class="{'center-on-desktop': centerOnDesktop }")
        .swatch-outer-wrap(v-for="(swatch, index) in swatches" :class="{'best-match': swatch.bestMatch || swatch.subscribed}" :key="index")
          span.best-match-text.color-white.xs-f-xxsmall.max-at-tweak(v-if="swatch.bestMatch || swatch.subscribed") {{swatch.subscribed ? 'Subscribed' : 'Best Match'}}
          PdpSwatchButton.swatch-wrap(:disabled="swatch.disabled" :img-alt-text="swatch.imageAltText" :selected="swatch.selected" :label="swatch.title" :img-url="swatch.imageUrl" @click="selectSwatch(swatch, index)")


</template>

<script>
  import { mapGetters, mapState } from 'vuex';
  import PdpSwatchButton from "@components/PDP/PdpSwatchButton";

  export default {
    name: "SwatchSelector",

    components: {
      HorizontalSelector: () =>  import("@components/horizontalSelector"),
      PdpSwatchButton
    },

    props: {
      swatches: {
        type: Array,
        required: true
      },
      showArrows: {
        type: Boolean,
        required: false,
        default: true,
      },
      centerOnDesktop: {
        type: Boolean,
        required: false,
        default: false
      }
    },

    data() {
      return {
        currentSlide: 0,
        mounted: false
      };
    },

    computed: {
      ...mapGetters('global', ['isMobile']),
      ...mapState('global', ['windowData']),

      breakpoint() {
        return this.windowData.breakpoint;
      },
    },

    watch: {
      swatches: {
        immediate: true,
        handler() {
          if (this.swatches && this.swatches.length && !this.mounted) {
            this.mounted = true;
            const selectedSwatchIndex = this.swatches.findIndex(({ selected }) => !!selected);
            this.selectSwatch(this.swatches[selectedSwatchIndex], selectedSwatchIndex);
          }
        }
      }
    },

    methods: {
      selectSwatch(swatch, index) {
        this.currentSlide = index;
        this.$emit('swatch-selected', swatch);
      },

      swipeLeft(num) {
        num = Math.ceil(num);
        if (this.swatches[this.currentSlide + num]) {
          this.currentSlide = this.currentSlide + num;
        } else {
          this.currentSlide = this.swatches.length - 1;
        }
      },

      swipeRight(num) {
        num = Math.ceil(num);
        if (this.swatches[this.currentSlide - num]) {
          this.currentSlide = this.currentSlide - num;
        } else {
          this.currentSlide = 0;
        }
      },

      clickLeft() {
        this.swipeRight(2);
      },

      clickRight() {
        this.swipeLeft(2);
      },
    }
  };
</script>

<style scoped lang="stylus">
  .swatch-selector
    position relative
    padding-left 1.5em
    padding-right 1.5em

    .center-on-desktop
      justify-content center
      display flex

    .mobile-swatches
      overflow hidden

    .swatch-outer-wrap
      position relative
      display inline-block
      vertical-align top
      border 1px solid transparent
      padding-top 1.75em
      text-align center

      &.selected
        padding 1.75em 0.25em 0.5em

      &.best-match
        border-color ui-color-7

      .best-match-text
        position absolute
        top 0
        left 0
        right 0
        background ui-color-7
        text-align center
        padding 0.25em
        padding-top 0.2em

    .swatch-wrap
      position relative
      display inline-block
      vertical-align top
      width 5em
      text-align center
      white-space normal
      padding 0

      @media mq-mobile
        width 4.8em

    .left-arrow
    .right-arrow
      position absolute
      top 0
      bottom 0
      width 2.5em
      text-align center

      .icon-caret-right
      .icon-caret-left
        position absolute
        top 50%
        left 0
        right 0
        margin-top -0.75em

    .left-arrow
      left 0

    .right-arrow
      right 0

    @media mq-tablet-less
      padding-left 2.5em
      padding-right 2.5em

</style>
